import apiClient from './client'
import type { Coach, CreateCoachRequest, UpdateCoachRequest, Group } from '@/types'

export type DesktopCoach = Coach & { bio?: string }
export type CoachUpdate = UpdateCoachRequest & { bio?: string; clear_phone?: boolean; clear_email?: boolean }
export const coachesApi = {
  getGroups: async (id: string): Promise<Group[]> => { const { data } = await apiClient.get(`/coaches/${id}/groups`); return data },
  getByAssistantId: async (assistantId: string): Promise<DesktopCoach[]> => {
    const { data } = await apiClient.get(`/assistants/${assistantId}/coaches`)
    return data
  },

  getById: async (_assistantId: string, id: string): Promise<DesktopCoach> => {
    const { data } = await apiClient.get(`/coaches/${id}`)
    return data
  },

  create: async (assistantId: string, req: CreateCoachRequest & { bio?: string }): Promise<DesktopCoach> => {
    const { data } = await apiClient.post(`/assistants/${assistantId}/coaches`, req)
    return data
  },

  update: async (_assistantId: string, id: string, req: CoachUpdate): Promise<DesktopCoach> => {
    const { data } = await apiClient.put(`/coaches/${id}`, req)
    return data
  },

  delete: async (_assistantId: string, id: string): Promise<void> => {
    await apiClient.delete(`/coaches/${id}`)
  },

  assignToGroup: async (_assistantId: string, coachId: string, groupId: string): Promise<void> => {
    await apiClient.post(`/coaches/${coachId}/assign-group`, { group_id: groupId })
  },

  removeFromGroup: async (_assistantId: string, coachId: string, groupId: string): Promise<void> => {
    await apiClient.post(`/coaches/${coachId}/remove-group`, { group_id: groupId })
  },
}
